import { config, library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import React, { lazy } from 'react';
import { Container } from 'react-bootstrap';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import { Footer } from './app/shared/component/layout/footer';
import MainLayout from './mainLayout';
import { ApplicationLoader } from './app/shared/component/loader/application-loader';
import { Outlet } from 'react-router';

config.autoAddCss = false;
library.add(fas);

const MainDashboard = lazy(() => import('./app/dashboards/main'));
const EntryForm = lazy(() => import('./app/entry-form/entry-form'));
const Profile = lazy(() => import('./app/profile/profile'));

const App: React.FC<React.PropsWithChildren<any>> = () => {
  const router = createBrowserRouter(
    [
      {
        element: <MainLayout />,
        hydrateFallbackElement: <ApplicationLoader />,
        children: [
          {
            element: (
              <Container fluid style={{ minHeight: '82vh' }}>
                <Outlet />
              </Container>
            ),
            children: [
              {
                index: true,
                errorElement: <div>Something went wrong</div>,
                path: '/home/*',
                element: <MainDashboard />,
              },
              {
                path: '/files/:id/*',
                element: <EntryForm />,
              },
              {
                path: '/profile"',
                element: <Profile />,
              },
            ],
          },
          {
            path: '*',
            element: <Navigate to={'/home'} />,
          },
        ],
      },
    ],
    {
      basename: '/maf-external-portal',
    }
  );

  return (
    <>
      <article className="mb-3">
        <Container fluid>
          <RouterProvider router={router} />
        </Container>
      </article>
      <Footer />
    </>
  );
};

export default App;
